import React, { useEffect } from 'react';
import './Legaldocuments.css';

const LegalDocuments = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const documents = [
    { title: 'Terms & Conditions', desc: 'Our general terms and conditions of service' },
    { title: 'Privacy Policy', desc: 'How we collect and protect your personal data' },
    { title: 'Risk Disclosure', desc: 'Important information about trading risks' },
    { title: 'Client Agreement', desc: 'Legal agreement between you and BGI Assets' },
    { title: 'Order Execution Policy', desc: 'How we execute your trading orders' },
    { title: 'Complaints Policy', desc: 'How to raise and resolve complaints' }
  ];

  return (
    <div className="page-container">
      <div className="container">
        <button className="back-button" onClick={() => window.history.back()}>
          <span>←</span><span>Back to Home</span>
        </button>

        <h1>Legal Documents</h1>
        <p className="subtitle">Important legal information and regulatory documents.</p>

        <div className="documents-grid">
          {documents.map((doc, index) => (
            <div key={index} className="document-card">
              <h3>📄 {doc.title}</h3>
              <p>{doc.desc}</p>
              <button className="download-btn">Download PDF</button>
            </div>
          ))}
        </div>

        <div className="section">
          <h2>Important Information</h2>
          <p>Please read all legal documents carefully before opening an account. Trading CFDs and leveraged products involves significant risk of loss.</p>
        </div>
      </div>
    </div>
  );
};

export default LegalDocuments;